/**
 * Contributing Translations Module (Portuguese)
 * 
 * @module contributing
 * @language pt
 */

export const contributing = {
  contributing: {
    // Hero Section
    pageTitle: "Contribuindo para o Youth Futures",
    heroSubtitle: "Uma iniciativa de pesquisa colaborativa dedicada a entender e avançar a liderança jovem globalmente",
    heroDescription: "Convidamos instituições, organizações, pesquisadores, membros e parceiros comunitários a contribuir com dados, insights e expertise que fortaleçam nossa plataforma.",
    
    // Why Contribute Section
    whyContributeTitle: "Por Que Contribuir?",
    whyContributeSubtitle: "Sua contribuição faz uma diferença real na compreensão da liderança jovem global",
    
    globalImpact: "Impacto Global",
    globalImpactDesc: "Seus dados alcançam formuladores de políticas, investidores, membros JCI em todo o mundo e a comunidade global de liderança jovem—criando impacto tangível em como jovens líderes são desenvolvidos e reconhecidos.",
    
    academicRecognition: "Reconhecimento Acadêmico",
    academicRecognitionDesc: "Citação formal em relatórios técnicos, publicações científicas, apresentações em congressos internacionais, certificados de colaboração e reconhecimento em mídias sociais—válido para currículo acadêmico e portfólios profissionais.",
    
    rigorousMethodology: "Metodologia Rigorosa",
    rigorousMethodologyDesc: "Todas as contribuições seguem padrões internacionais (diretrizes da ONU, melhores práticas acadêmicas) garantindo máxima credibilidade para sua instituição e resultados.",
    
    openAccess: "Acesso Aberto",
    openAccessDesc: "Todas as descobertas estão disponíveis publicamente através de dashboards interativos, relatórios técnicos (PDF), arquivos de dados (CSV/Excel), sob licença Creative Commons—gratuito para uso não comercial.",
    
    formalRecognition: "Reconhecimento Formal",
    formalRecognitionDesc: "Citação em relatórios técnicos e apresentações, menção em congressos e eventos internacionais, certificado digital de colaboração, reconhecimento nos canais de mídia social da JCI, válido para credenciais profissionais.",
    
    // Who Can Contribute Section
    whoCanContributeTitle: "Quem Pode Contribuir?",
    whoCanContributeSubtitle: "Perspectivas diversas fortalecem nossa plataforma de pesquisa",
    
    nationalOrgs: "Organizações Nacionais JCI",
    nationalOrgsDesc: "Compartilhe dados estratégicos sobre desenvolvimento de liderança, engajamento de membros, impacto de programas e iniciativas regionais.",
    nationalOrgsDetails: "Estatísticas e demografia de membros nacionais, resultados de programas e projetos alinhados ao Plano Estratégico JCI 2023-2027, tendências e insights de liderança regional, resultados de parcerias e colaborações, métricas de treinamento e desenvolvimento, dados de participação em eventos, iniciativas estratégicas e inovações.",
    nationalOrgsWhy: "Ajude o Observatório a refletir a verdadeira diversidade e impacto da JCI em todas as regiões e países.",
    
    committees: "Comitês e Conselhos JCI",
    committeesDesc: "Comitês especializados contribuem com expertise em dimensões específicas de desenvolvimento de liderança.",
    committeesDetails: "Conselhos de Desenvolvimento (Estratégico, Operacional, Educacional, Impacto), dados e métricas específicas de conselhos, melhores práticas e metodologias, resultados de desenvolvimento de membros, resultados de treinamento e certificação, indicadores de desempenho regional.",
    committeesWhy: "Permita que o Observatório apresente perspectivas especializadas sobre como a JCI desenvolve líderes em todas as dimensões estratégicas.",
    
    individualMembers: "Membros Individuais JCI",
    individualMembersDesc: "Todo membro tem insights e experiências valiosos para compartilhar.",
    individualMembersDetails: "Histórias pessoais de desenvolvimento de liderança, feedback e resultados de participação em programas, experiências de desenvolvimento de habilidades e treinamento, insights de mentoria e networking, exemplos de avanço na carreira, projetos de impacto comunitário, correções e atualizações de qualidade de dados, sugestões metodológicas e feedback.",
    individualMembersWhy: "As vozes dos membros garantem que o Observatório reflita jornadas reais de liderança e experiências vividas dentro da JCI.",
    
    researchPartners: "Parceiros de Pesquisa e Instituições Acadêmicas",
    researchPartnersDesc: "Universidades, centros de pesquisa e grupos acadêmicos contribuem com pesquisa e análise original.",
    researchPartnersDetails: "Artigos de pesquisa acadêmica e estudos, estudos longitudinais sobre desenvolvimento de membros JCI, análise comparativa com outras organizações de liderança, revisões e validações metodológicas, projetos de pesquisa estudantil, mapeamento e análise institucional, estudos de alinhamento curricular, conjuntos de dados e descobertas publicadas.",
    researchPartnersWhy: "Parcerias acadêmicas validam o Observatório como uma plataforma de pesquisa credível alinhada com padrões internacionais.",
    
    educationalInstitutions: "Instituições de Ensino e Centros de Treinamento",
    educationalInstitutionsDesc: "Escolas, universidades, centros vocacionais e organizações de treinamento contribuem com dados educacionais.",
    educationalInstitutionsDetails: "Mapeamento de currículo de liderança, matrícula e resultados de estudantes membros JCI, resultados de programas de treinamento, métricas de desenvolvimento de habilidades, dados de emprego de graduados, resultados de programas de parceria, alinhamento de cursos com a estrutura JCI, dados de certificação e credenciais.",
    educationalInstitutionsWhy: "Dados educacionais revelam como o desenvolvimento de liderança JCI se traduz em avanço acadêmico e profissional.",
    
    governmentNgos: "Governo, ONGs e Parceiros Institucionais",
    governmentNgosDesc: "Agências governamentais, organizações internacionais e parceiros da sociedade civil contribuem com dados estratégicos.",
    governmentNgosDetails: "Alinhamento de políticas públicas com iniciativas JCI, resultados de parcerias governamentais, dados de colaboração com organizações internacionais, eficácia de parcerias com ONGs, métricas de impacto comunitário, dados de sustentabilidade e responsabilidade social, reconhecimento e endossos institucionais, alinhamento regulatório e de estruturas.",
    governmentNgosWhy: "Parcerias institucionais demonstram a credibilidade da JCI e alinhamento com agendas globais de desenvolvimento.",
    
    // How to Contribute Section
    howToContributeTitle: "Como Contribuir",
    howToContributeSubtitle: "Envie sua contribuição por email com as informações necessárias",
    
    contributionFormTitle: "Formulário de Contribuição",
    contributionFormDesc: "Envie sua contribuição usando nosso formulário. Todos os campos são obrigatórios.",
    sendTo: "As informações serão enviadas para:",
    
    yourInformation: "Suas Informações",
    fullName: "Nome Completo",
    fullNameDesc: "Seu nome completo",
    affiliatedOrg: "Organização Afiliada",
    affiliatedOrgDesc: "Organização Nacional, Comitê, Instituição, Empresa, etc.",
    emailAddress: "Endereço de Email",
    emailAddressDesc: "Onde entraremos em contato com você",
    yourRole: "Seu Cargo",
    yourRoleDesc: "Posição/função na sua organização",
    
    contributionDetails: "Detalhes da Contribuição",
    contributionType: "Tipo de Contribuição",
    contributionTypeDesc: "Selecione a categoria: Dados de Pesquisa, Resultados de Programa, Insights de Membros, Parceria Institucional, Resultados de Treinamento, Análise Estratégica, Melhoria de Qualidade, Outro",
    contributionDescription: "Descrição da Contribuição",
    contributionDescriptionDesc: "Descreva brevemente o que você está oferecendo e por que é relevante (mínimo 20 caracteres)",
    dataFormat: "Formato dos Dados",
    dataFormatDesc: "Como os dados estão disponíveis? (Excel, PDF, Artigo científico, Link, Banco de dados, Relatório, Outro)",
    dataScope: "Escopo dos Dados",
    dataScopeDesc: "Escopo geográfico e período de tempo coberto",
    verificationStatus: "Status de Verificação",
    verificationStatusDesc: "Estes dados são verificados/auditáveis? Sim / Não",
    
    authorization: "Autorização e Compromisso",
    citationAuth: "Autorizo o uso dos dados fornecidos no Observatório JCI, com atribuição formal de fonte em todos os materiais publicados",
    dataOwnership: "Confirmo que minha organização possui ou tem permissão para compartilhar estes dados",
    accuracy: "Certifico que os dados fornecidos são precisos e representam a melhor informação disponível",
    required: "Obrigatório",
    
    // Contribution Process Section
    processTitle: "Processo de Contribuição",
    processSubtitle: "Da submissão à publicação em 2-4 semanas",
    
    step1: "Contato e Submissão",
    step1Desc: "Envie sua proposta por email com o formulário preenchido",
    step2: "Revisão Inicial",
    step2Desc: "Nossa equipe avalia relevância, qualidade e alinhamento com valores e metodologia JCI",
    step3: "Verificação de Dados",
    step3Desc: "Verificamos fontes de dados, metodologias e precisão antes da integração",
    step4: "Integração",
    step4Desc: "Dados e insights são incorporados à plataforma do Observatório",
    step5: "Reconhecimento Formal",
    step5Desc: "Sua contribuição recebe citação formal, certificado e reconhecimento público",
    
    timeline: "Prazo: 2-4 semanas da submissão até a publicação",
    
    // Our Commitments Section
    commitmentsTitle: "Nossos Compromissos",
    commitmentsSubtitle: "O que prometemos a cada contribuidor",
    
    transparencyProtocol: "Protocolo de Transparência",
    transparencyProtocolDesc: "Mantemos total transparência em todas as contribuições: todas as fontes citadas com créditos completos, nomes de organizações e contribuidores claramente identificados, título do trabalho/conjunto de dados e data de publicação documentados, link completo e DOI quando disponível, referências bibliográficas completas, metodologia e fórmulas de cálculo explicadas, limitações dos dados claramente declaradas. Cada contribuição é rastreável e auditável.",
    
    openMethodology: "Metodologia Aberta",
    openMethodologyDesc: "O Observatório opera com total transparência metodológica: todas as estruturas e indicadores documentados, metodologias de cálculo totalmente explicadas, disponível para auditoria acadêmica pública, relatórios técnicos com detalhes completos, planilhas de cálculo com todas as fórmulas, FAQ abordando questões metodológicas, revisões e atualizações metodológicas regulares. Você pode verificar tudo o que publicamos.",
    
    formalRecognitionCommitment: "Reconhecimento Formal",
    formalRecognitionCommitmentDesc: "Contribuidores recebem reconhecimento abrangente: citação em todos os relatórios técnicos e publicações, menção em apresentações em congressos internacionais JCI, certificado digital de colaboração (para download), reconhecimento nos canais de mídia social da JCI, destaque na seção \"Contribuidores\" do Observatório, convite para coautoria de estudos especiais, acesso prioritário a novos conjuntos de dados do Observatório. Sua contribuição constrói a credibilidade da sua instituição.",
    
    publicAccess: "Acesso Público",
    publicAccessDesc: "Todos os dados e insights do Observatório são disponibilizados gratuitamente: dashboard online interativo, relatórios técnicos em formato PDF, arquivos de dados em formato CSV/Excel, Licença Creative Commons BY-NC-SA 4.0, gratuito para uso acadêmico não comercial, licenciamento comercial disponível mediante solicitação, acesso API para parceiros de pesquisa registrados. Seus insights alcançam uma audiência global.",
    
    dataQualityStandards: "Padrões de Qualidade de Dados",
    dataQualityStandardsDesc: "Mantemos práticas rigorosas de qualidade de dados: todos os dados devem ser verificados e auditáveis, nenhum dado sintético ou estimado sem notação clara, fontes devem ser publicamente documentadas, metodologia deve ser replicável, precisão dos dados verificada antes da publicação, auditorias e revisões de qualidade regulares, procedimentos de correção para erros. Excelência é inegociável.",
    
    // Contribution Types Section
    contributionTypesTitle: "Tipos de Contribuição e Exemplos",
    contributionTypesSubtitle: "Diferentes formas de contribuir para o Observatório",
    
    researchData: "Dados de Pesquisa",
    researchDataExamples: "Artigos de pesquisa acadêmica sobre liderança jovem, estudos longitudinais sobre desenvolvimento de membros, análises comparativas com organizações pares, resultados de pesquisas e análises estatísticas",
    
    programResults: "Resultados de Programas",
    programResultsExamples: "Métricas de resultados de programas JCI, avaliações de impacto de projetos, dados de conclusão de treinamento e certificação, estatísticas de engajamento e retenção de membros",
    
    memberInsights: "Insights de Membros",
    memberInsightsExamples: "Dados demográficos de membros, exemplos de avanço na carreira, histórias de desenvolvimento de habilidades de liderança, resultados de programas de mentoria",
    
    institutionalPartnerships: "Parcerias Institucionais",
    institutionalPartnershipsExamples: "Dados de eficácia de parcerias, resultados de colaborações, resultados de programas conjuntos, endossos institucionais",
    
    trainingOutcomes: "Resultados de Treinamento",
    trainingOutcomesExamples: "Métricas de programas de treinamento, dados de certificação, avaliações de desenvolvimento de habilidades, análises de alinhamento educacional",
    
    strategicAnalysis: "Análise Estratégica",
    strategicAnalysisExamples: "Tendências e insights regionais, análises setoriais específicas, documentação de melhores práticas, estudos de caso de inovação",
    
    qualityImprovements: "Melhorias de Qualidade",
    qualityImprovementsExamples: "Correções e atualizações de dados, sugestões metodológicas, identificação de informações faltantes, recomendações de melhoria de processos",
    
    // Data Requirements Section
    dataRequirementsTitle: "Requisitos de Dados",
    dataRequirementsSubtitle: "Para que as contribuições sejam aceitas, certifique-se de:",
    
    mandatoryElements: "Elementos Obrigatórios",
    mandatoryList: "Identificação clara da fonte de dados, período coberto (intervalo de datas), escopo geográfico (regional, nacional, global), metodologia de coleta de dados, tamanho da amostra (se aplicável), declaração de verificação, declaração de permissão para compartilhar",
    
    recommendedElements: "Elementos Recomendados",
    recommendedList: "Pessoa de contato para dúvidas, documentação de suporte, estudos ou referências relacionados, limitações ou ressalvas, uso/interpretação sugeridos, conjuntos de dados relacionados para referência cruzada, frequência de atualização (se recorrente)",
    
    // FAQ Section
    faqTitle: "Perguntas Frequentes",
    faqSubtitle: "Dúvidas comuns sobre contribuir para o Observatório",
    
    faq1Q: "Quanto tempo leva o processo de contribuição?",
    faq1A: "Tipicamente 2-4 semanas da submissão até a publicação, dependendo da complexidade dos dados e etapas de verificação necessárias.",
    
    faq2Q: "Minha organização será creditada?",
    faq2A: "Sim, absolutamente. Todas as contribuições recebem citação formal em cada publicação onde aparecem.",
    
    faq3Q: "Podemos contribuir com dados confidenciais?",
    faq3A: "Geralmente não—o Observatório requer dados públicos e verificáveis. No entanto, dados agregados ou anonimizados podem ser possíveis. Entre em contato para discutir situações específicas.",
    
    faq4Q: "Precisamos contribuir com dados para usar o Observatório?",
    faq4A: "Não. O Observatório é gratuito e aberto a todos. Contribuições são voluntárias e apreciadas, mas não obrigatórias.",
    
    faq5Q: "O que acontece se encontrarmos um erro em nossos dados?",
    faq5A: "Temos um procedimento de correção. Entre em contato imediatamente e atualizaremos os dados e publicaremos um aviso de errata.",
    
    faq6Q: "Contribuições podem ser atualizadas?",
    faq6A: "Sim. Atualizações anuais são incentivadas. Envie dados atualizados a qualquer momento com um histórico de versão claro.",
    
    faq7Q: "Há algum custo para contribuir?",
    faq7A: "Não. Contribuições são voluntárias. Valorizamos sua expertise e insights.",
    
    // Team & Contact Section
    teamTitle: "Nossa Equipe",
    teamSubtitle: "Entre em contato para iniciar sua jornada de contribuição",
    
    observatoryTeam: "Equipe do Observatório JCI",
    dashcityTeam: "Equipe Dashcity",
    email: "Email",
    website: "Website",
    contactForm: "Formulário de Contato",
    
    developmentCouncils: "Coordenação dos Conselhos de Desenvolvimento",
    strategicCouncil: "Conselho de Desenvolvimento Estratégico",
    operationalCouncil: "Conselho de Desenvolvimento Operacional",
    educationalCouncil: "Conselho de Desenvolvimento Educacional",
    impactCouncil: "Conselho de Desenvolvimento de Impacto",
    
    // Our Commitments to You Section
    partnershipTitle: "Nossos Compromissos com Você",
    partnershipSubtitle: "Quando você contribui para o Observatório JCI, você está se associando com:",
    
    commitment1: "Uma organização global de liderança jovem com 100+ anos de história e presença em 120 países",
    commitment2: "Uma instituição orientada por dados alinhada com os Objetivos de Desenvolvimento Sustentável da ONU e melhores práticas internacionais",
    commitment3: "Uma plataforma de pesquisa credível construída sobre metodologia rigorosa e processos transparentes",
    commitment4: "Uma comunidade inclusiva que valoriza perspectivas e vozes diversas",
    commitment5: "Um movimento crescente transformando como jovens líderes são desenvolvidos e reconhecidos",
    
    // Why Your Data Matters Section
    whyDataMattersTitle: "Por Que Seus Dados Importam",
    whyDataMattersSubtitle: "O Observatório JCI existe para responder questões críticas:",
    
    question1: "Como jovens líderes são desenvolvidos globalmente?",
    question2: "Quais habilidades são mais importantes para futuros líderes?",
    question3: "Como a JCI transforma a vida dos membros?",
    question4: "O que cria impacto de liderança sustentável?",
    question5: "Como mentoria, treinamento e comunidade moldam líderes?",
    
    dataMattersConclusion: "Sua contribuição ajuda a responder essas perguntas com dados reais, experiências reais e impacto real. Juntos, estamos construindo a plataforma autoritativa para entender o desenvolvimento de liderança jovem.",
    
    // CTA Section
    ctaTitle: "Pronto para Contribuir?",
    ctaSubtitle: "Três Passos Simples",
    
    ctaStep1: "Preencha o formulário com os detalhes da sua contribuição",
    ctaStep2: "Envie para tmariano@jci.cc com quaisquer arquivos de suporte",
    ctaStep3: "Aguarde confirmação - nossa equipe entrará em contato em até 5 dias úteis",
    
    questionsTitle: "Dúvidas Antes de Começar?",
    questionsContact: "Envie um email para: observatory@jci.cc",
    questionsAlternative: "Ou entre em contato com seu representante regional do Conselho de Desenvolvimento através da sua Organização Nacional.",
    
    startContributing: "Começar a Contribuir",
    contactUs: "Entre em Contato",
    
    // Checklist
    checklistTitle: "Lista de Verificação da Contribuição",
    checklistSubtitle: "Antes de enviar, verifique se você tem:",
    
    checkItem1: "Informações completas do contribuidor",
    checkItem2: "Tipo de contribuição claramente selecionado",
    checkItem3: "Documentação da fonte de dados",
    checkItem4: "Período e escopo geográfico definidos",
    checkItem5: "Declaração de verificação/auditoria",
    checkItem6: "Autorização para compartilhar",
    checkItem7: "Arquivos de suporte prontos",
    checkItem8: "Informações de contato para acompanhamento",
    
    // Footer info
    lastUpdated: "Última Atualização: Dezembro 2025",
    availableLanguages: "Disponível em Inglês, Português, Espanhol, Francês e Japonês",
    joinCommunity: "Junte-se à comunidade de contribuidores construindo o futuro da pesquisa em liderança jovem!",
  },
} as const;
